import React from 'react'
import CustomLink from '@/shared/components/customLink'
import { RightBracketArrow } from '@/shared/Icons'
function StatsCardTable({ data, cardtitle }: any) {
  return (
    <>
      {data?.length !== 0 && (
        <section className="md:border border-tabBorder md:rounded-xl">
          <div className={`font-semibold flex flex-col p-0 bg-cardBg rounded-xl`}>
            <>
              <p className="font-medium hidden md:block px-4 py-3 rounded-t-xl text-xs md:text-base text-textDselected bg-headersActive">
                {cardtitle}
              </p>
              <div className="md:px-6 px-2 dark:px-0 dark:md:px-6">
                {data?.map((series: any) => {
                  return (
                    <CustomLink
                      key={series?.description}
                      href={`${series?.url}`}
                      className="flex py-4 justify-between first:border-t-0 border-t border-tabBorder items-center text-sm md:text-base font-medium text-textOffWhite"
                    >
                      <>
                        <span className="overflow-hidden whitespace-nowrap flex hover:text-primary-500">
                          {series?.description}
                        </span>
                        <div className="text-subSectionText">
                          <RightBracketArrow />
                        </div>
                      </>
                    </CustomLink>
                  )
                })}
              </div>
            </>
          </div>
        </section>
      )}
    </>
  )
}

export default StatsCardTable
